// extracted by mini-css-extract-plugin
export default {"paginationContainer":"Pagination_paginationContainer__3+S4W","pgButton":"Pagination_pgButton__-zovf","pgSpan":"Pagination_pgSpan__QsyYb"};